import { render, staticRenderFns } from "./ListOwner.vue?vue&type=template&id=626679e5&scoped=true&"
import script from "./ListOwner.vue?vue&type=script&lang=js&"
export * from "./ListOwner.vue?vue&type=script&lang=js&"
import style0 from "./ListOwner.vue?vue&type=style&index=0&id=626679e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626679e5",
  null
  
)

export default component.exports